import { useContext, useEffect } from 'react';
import { ServerStylesContext } from '../elements/style/serverStyles';
import { mountCustomCss } from '../elements/style/customStyleSheet';

// Keeps the store's own stylesheet on the page in step with the one the page was sent, or the one the
// code editor is holding, and takes it away when the page goes.

// Mounts the stylesheet a page should wear, replacing it whenever it changes.
export function useCustomCss(css: string): void {
  // On the server the store's sheet goes to the page's head with the drawing, since effects never run there.
  const collected = useContext(ServerStylesContext);
  if (collected) collected.custom = css;
  useEffect(() => {
    mountCustomCss(document, css);
  }, [css]);
  useEffect(() => () => mountCustomCss(document, ''), []);
}
